import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './locales/de/translation.json';
import en from './locales/en/translation.json';
import fr from './locales/fr/translation.json';
import it from './locales/it/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      fr: { translation: fr },
      it: { translation: it },
    },
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'examcraft_language',
    },
    saveMissing: process.env.NODE_ENV === 'development',
    missingKeyHandler: (lngs: readonly string[], ns: string, key: string) => {
      console.warn(`[i18n] Missing translation key: "${key}" [${lngs}]`);
    },
  })
  .catch((err: unknown) => {
    console.error('[i18n] Initialization failed:', err);
  });

export default i18n;
